import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M12 3L2 12h3v8h6v-6h2v6h6v-8h3L12 3zm5 15h-2v-6H9v6H7v-7.81l5-4.5 5 4.5V18z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 10.19V18h2v-6h6v6h2v-7.81l-5-4.5z",
  opacity: ".3"
})), 'HomeTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/HomeTwoTone.js
// module id = 4149
// module chunks = 2